import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { company } from '../data/site';

const WhatsAppButton = () => (
  <a
    href={company.whatsapp}
    className="whatsapp-float"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
  >
    <FaWhatsapp />
  </a>
);

export default WhatsAppButton;
